export default defineNuxtPlugin(nuxtApp => {
	const route = useRoute();

	function setCookie() {
		const cookie = useCookie(`affiliate_lite`, route?.query?.cjevent, {expires: 45});
		cookie.value = route?.query?.cjevent;
	}

	if (route?.query?.hasOwnProperty('cjevent')) {
		setCookie();
	}
});
